import { useSearchParams } from 'react-router';

/**
 * {@link useUrlParam} is a react hook which returns a function that updates the url to
 * change a search parameter, and then pushes a history entry for that new url.
 *
 * Note: Do not try to change more than one param at a time. useUrlParams for that.
 */
export function useUrlParam(paramName: string) {
  const [params, setParams] = useSearchParams();

  const param = params.get(paramName) ?? undefined;

  function setParam(value?: string) {
    setParams((oldParams) => {
      if (value) {
        oldParams.set(paramName, value);
      } else {
        oldParams.delete(paramName);
      }
      return oldParams;
    });
  }

  return [param, setParam] as const;
}
